import { useSettings } from '@capsicum/common';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { v2SupportedDestinationsModalConfirmDisabledAtom } from '../../data-access';

export const useV2FTSupportedDestinationsWarningModalContent = () => {
	const [isConfirmDisabled, setConfirmedDisabled] = useAtom(v2SupportedDestinationsModalConfirmDisabledAtom);

	const {
		settings: { v2SendWarningModalLink }
	} = useSettings();

	const toggleConfirmDisabled = useCallback(() => setConfirmedDisabled(value => !value), [setConfirmedDisabled]);

	return {
		isConfirmDisabled,
		toggleConfirmDisabled,
		v2SendWarningModalLink
	};
};
